import axios from "axios";
import React, { Suspense, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import ShowcaseView from "../../components/ShowcaseView";
import Layout from "../../components/Layout";
import Pagination from "../../components/Pagination";
import Sectiontitle from "../../components/Sectiontitle";
import Spinner from "../../components/Spinner";
import type { ShowcaseItem } from "../../data/db/database";

const ShowcasePage: React.FC = () => {
  const [posts, setPosts] = useState<ShowcaseItem[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(6);

  useEffect(() => {
    let mounted = true;
    axios.get<ShowcaseItem[]>("/api/showcase").then((response) => {
      if (mounted) {
        const sorted = [...response.data].sort((a, b) =>
          b.publishedAt.localeCompare(a.publishedAt),
        );
        setPosts(sorted);
      }
    });
    return () => {
      mounted = false;
    };
  }, []);

  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = posts.slice(indexOfFirstPost, indexOfLastPost);

  const paginate = (
    e: React.MouseEvent<HTMLAnchorElement>,
    pageNumber: number,
  ) => {
    e.preventDefault();
    setCurrentPage(pageNumber);
  };

  return (
    <Layout>
      <Helmet>
        <title>Showcase - Nathan Hensher</title>
        <meta
          name="description"
          content="Nathan Hensher - Javascript Engineer - Showcase"
        />
      </Helmet>
      <Suspense fallback={<Spinner />}>
        <div className="mi-about mi-section mi-padding-top mi-padding-bottom">
          <div className="container">
            <Sectiontitle title="Showcase components" />
            <ShowcaseView components={currentPosts} />
            {!(posts.length > postsPerPage) ? null : (
              <Pagination
                className="mt-50"
                itemsPerPage={postsPerPage}
                totalItems={posts.length}
                paginate={paginate}
                currentPage={currentPage}
              />
            )}
          </div>
        </div>
      </Suspense>
    </Layout>
  );
};

export default ShowcasePage;
